import * as Yup from "yup";

const centroCustoValidator = Yup.object().shape({
  descricao: Yup.string().required("Descrição"),
  idPai: Yup.number().nullable(),
});

export default centroCustoValidator;
